import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type IGetLocationRequest,
  type IGetLocationResponse,
  fetchGetLocation as fetchGetLocationApi,
} from '@/repositories/manually-added/shared/monolith-python/v1/get-location';

export const fetchGetLocation = withTypeSafeApiResult<IGetLocationRequest, IGetLocationResponse>(fetchGetLocationApi);
